export default __webpack_public_path__ + "static/media/7.9f970cce.jpg";